var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTagNew = function SvgTagNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 36",
    fill: "none",
    preserveAspectRatio: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m37.127 36.001-9.071-4.19-10.583 3.81-2.859-7.791-13.102.296 7.898-6.6L0 15.641l10.583-2.666-2.181-7.843 10.255 3.622L30.381.001l4.946 8.753L49.22 6.29l-1.184 7.237 6.142 1.315-6.215 3.278L57 22.28l-11.189 2.594 2.226 4.651-9.902-1.142L37.127 36Z",
    fill: "currentColor"
  })));
};

export default SvgTagNew;